import { vservice } from '@niknevis/vue-modules'
import { PanelCampaignService } from '@/modules/base-campaign/services/panel-campaign.service'

@vservice()
export class PanelDashboardUseCase {
  constructor(
    private readonly campaignService: PanelCampaignService
  ) {
  }

  allCampaigns() {
    return this.campaignService.allCampaigns()
  }

}
